<span class="description">Status:</span>

@if (isEditable) {
<span class="items read-only">
  @for (status of uncompletedStatuses; track status) {
  <span
    class="btn {{ status.type_value | className }}"
    [class.active]="isActive(status)"
  >
    {{ status.type_label }}
  </span>
  }
  <span
    class="btn {{ completedStatus.type_value | className }}"
    [class.active]="isActive(completedStatus)"
  >
    {{ completedStatus.type_label }}
  </span>
</span>
} @if (!isEditable) {
<span class="items">
  @for (status of uncompletedStatuses; track status) {
  <button
    [disabled]="status.type_value === 'INITIATED'"
    (click)="tryUpdate(status)"
    class="btn {{ status.type_value | className }}"
    [class.active]="isActive(status)"
  >
    {{ status.type_label }}
  </button>
  }
  <button
    routerLink="options/close"
    class="btn {{ completedStatus.type_value | className }}"
    [class.active]="isActive(completedStatus)"
  >
    {{ completedStatus.type_label }}
  </button>
</span>
}
